import { createRouter, createWebHistory } from 'vue-router';

// User registration pages
import Register from '@/views/Register/RegisterView.vue';
import Login from '@/views/login/LoginView.vue';
import Reset from '@/views/Reset/ResetView.vue';

// Navigation Pages
import Home from '@/views/Home/HomeView.vue';
import Create from '@/views/Create/CreateView.vue';
import Drive from '@/views/Drive/DriveView.vue';
import Settings from '@/views/Settings/SettingsView.vue';
import Chat from '@/views/Chat/OneChatView.vue';
import FirstTimeLogin from '@/views/FirstTimeLogin/FirstTimeLogin.vue';
import ResetSent from '@/views/ResetPasswordSent/ResetSent.vue';
import ResetLinkSent from '@/views/ResetLinkSent/ResetLinkSent.vue';
import AuditTrail from '@/views/AuditTrail/AuditTrailView.vue';
import OneTimePassword from '@/views/OneTimePassword/OneTimePassword.vue';
import MainSettings from '@/views/MainSettings/MainSettings.vue';
import ProfileView from '@/views/Profile/ProfileView.vue';
import PermissionView from '@/views/Permission/PermissionVIew.vue';
import RoleView from '@/views/Role/RoleView.vue';
import RolePermissionsView from '@/views/RolePermissions/RolePermissionsView.vue';
import AccessControlView from '@/views/AccessControl/AccessControlView.vue';
import IndividualDashboard from '@/views/IndividualDashboard/IndividualDashboard.vue'
import SystemConfigureView from '@/views/System_Configure/SystemConfigureView.vue';
import UserPermissionsView from '@/views/UserPermissions/UserPermissionsView.vue';
import SupersetManager from '@/views/SupersetManager/SupersetManager.vue';
import MicrosoftSSOSuccess from '@/views/MicrosoftSSO/MicrosoftSSOSuccess.vue';
import MicrosoftMarketplaceActivate from '@/views/MicrosoftMarketplace/MicrosoftMarketplaceActivate.vue';
import MicrosoftMarketplaceSuccess from '@/views/MicrosoftMarketplace/MicrosoftMarketplaceSuccess.vue';
import MicrosoftMarketplaceError from '@/views/MicrosoftMarketplace/MicrosoftMarketplaceError.vue';
import MicrosoftMarketplaceSetupSubmitted from '@/views/MicrosoftMarketplace/MicrosoftMarketplaceSetupSubmitted.vue';
import PlatformManagementView from '@/views/PlatformManagement/PlatformManagementView.vue';
import AddPlatformConfigView from '@/views/PlatformManagement/AddPlatformConfigView.vue';
import { SYSTEM_MANAGEMENT_ENDPOINTS, build_system_management_url } from '@/constants/system_management_endpoints.js';
import ZivaView from '@/views/Ziva/ZivaView.vue';

const routes = [
  {
    path: '/register',
    name: 'Register',
    component: Register
  },

  {
    path: '/',
    alias: '/login',
    name: 'Login',
    component: Login,
    meta: { requires_auth: false, public: true },
    beforeEnter: (to, from, next) => {
    const token = localStorage.getItem('token');
    if (token) {
      const next_url = to.query.next;
      if (is_safe_app_redirect(next_url)) {
        next(next_url);
        return;
      }
      next({ name: 'IndividualDashboard' });
      return;
    }
    next();
  }
  },

  {
    path: '/reset',
    name: 'Reset',
    component: Reset
  },

  {
    path: '/auth/microsoft/success',
    name: 'MicrosoftSSOSuccess',
    component: MicrosoftSSOSuccess,
    meta: { requires_auth: false, public: true },
  },

  {
    path: '/marketplace/microsoft/activate',
    name: 'MicrosoftMarketplaceActivate',
    component: MicrosoftMarketplaceActivate,
    meta: { public: true, requires_auth: false },
  },

  {
    path: '/marketplace/microsoft/success',
    name: 'MicrosoftMarketplaceSuccess',
    component: MicrosoftMarketplaceSuccess,
    meta: { public: true, requires_auth: false },
  },

  {
    path: '/marketplace/microsoft/setup-submitted',
    name: 'MicrosoftMarketplaceSetupSubmitted',
    component: MicrosoftMarketplaceSetupSubmitted,
    meta: { public: true, requires_auth: false },
  },

  {
    path: '/marketplace/microsoft/error',
    name: 'MicrosoftMarketplaceError',
    component: MicrosoftMarketplaceError,
    meta: { public: true, requires_auth: false },
  },

  {
    path: '/home_v1',
    name: 'Home',
    component: Home
  },
  {
    path: '/create',
    name: 'Create',
    component: Create
  },
  {
    path: '/drive',
    name: 'Drive',
    component: Drive
  },
    {
    path: '/settings',
    name: 'Settings',
    component: Settings
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat
  },
  {
    path: '/first_time_login',
    name: 'FirstTimeLogin',
    component: FirstTimeLogin
  },
  {
    path: "/reset_password_sent/:uidb64/:token",
    name: "ResetPasswordSent",
    component: ResetSent,
    props: true,
    meta: { requires_auth: false }, // No authentication required for reset password sent
  },
  {
  path: '/reset_link_sent',
  name: 'ResetLinkSent',
  component: ResetLinkSent,
  meta: { requires_auth: false },
  },
  {
    path: '/audit_trail',
    name: 'AuditTrail',
    component: AuditTrail
  },

  {
    path: '/otp',
    name: 'OneTimePassword',
    component: OneTimePassword
  },
  {
    path: '/main_settings',
    name: 'MainSettings',
    component: MainSettings
  },
  {
    path: '/profile',
    name: 'Profile',
    component: ProfileView
  },
  {
    path: '/permission',
    name: 'Permission',
    component: PermissionView
  },
  {
    path: '/role',
    name: 'Role',
    component: RoleView
  },
  {
    path: '/role_permissions/:id',
    name: 'RolePermissions',
    component: RolePermissionsView
  },
  {
    path: '/access_control',
    name: 'AccessControl',
    component: AccessControlView
  },
  {
    path: '/home',
    name: 'IndividualDashboard',
    component: IndividualDashboard
  },
  {
    path: '/system_configure',
    name: 'SystemConfigure',
    component: SystemConfigureView
  },
  {
    path: '/user_permissions/:user_id',
    name:'UserPermissions',
    component: UserPermissionsView,
  },
  {
    path: '/superset_manager',
    name: 'SupersetManager',
    component: SupersetManager
  },
  {
    path: '/platform_management',
    name: 'PlatformManagement',
    component: PlatformManagementView
  },
  {
    path: '/platform-management/add-config',
    name: 'AddPlatformConfig',
    component: AddPlatformConfigView
  },
  {
    path: '/support',
    redirect: '/home'
  },
  {
    path: '/ziva',
    name: 'Ziva',
    component: ZivaView
  },
];


const router = createRouter({
  history: createWebHistory(),
  routes
})



export function set_auth(token, user_id) {
  localStorage.setItem('token', token);
  localStorage.setItem('user_id', user_id);
}


export function set_drive_id(drive_id) {
  if (drive_id) {
    localStorage.setItem('drive_id', drive_id);
  }
}


export function get_drive_id() {
  return localStorage.getItem('drive_id');
}



export function set_user_details(user_details) {
  if (user_details) {
    localStorage.setItem('role', user_details.role || '');
    localStorage.setItem('first_name', user_details.first_name || '');
    localStorage.setItem('last_name', user_details.last_name || '');
    localStorage.setItem('email', user_details.email || '');
    localStorage.setItem('client_type', user_details.client_type || '');
    localStorage.setItem('company_id', user_details.company_id || '');


  }
}


export function get_user_details() {

  const user_role = localStorage.getItem('role');
  const first_name = localStorage.getItem('first_name');
  const last_name = localStorage.getItem('last_name');
  const email = localStorage.getItem('email');
  const client_type = localStorage.getItem('client_type');
  const company_id = localStorage.getItem('company_id');


  var user_details = {
    "role":user_role,
    "first_name":first_name,
    "last_name":last_name,
    "email":email,
    "client_type":client_type,
    "company_id":company_id

  }


  return user_details;
}

export function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop().split(';').shift();
  }
  return null;
}

export function is_valid_csrf_token(token) {
  return typeof token === 'string' && /^[A-Za-z0-9]{32,64}$/.test(token);
}

export function csrf_headers(token = getCookie('csrftoken')) {
  if (is_valid_csrf_token(token)) {
    return { 'X-CSRFToken': token };
  }

  const cookie_token = getCookie('csrftoken');
  if (is_valid_csrf_token(cookie_token)) {
    return { 'X-CSRFToken': cookie_token };
  }

  const stored_token = localStorage.getItem('playground_csrf_token');
  return is_valid_csrf_token(stored_token) ? { 'X-CSRFToken': stored_token } : {};
}

async function ensure_csrf_token() {
  if (Object.keys(csrf_headers()).length > 0) {
    return true;
  }

  try {
    const response = await fetch(
      build_system_management_url(SYSTEM_MANAGEMENT_ENDPOINTS.get_csrf_token),
      {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      },
    );
    const body = await response.json().catch(() => ({}));
    const response_token = body?.data?.csrf_token;
    const cookie_token = getCookie('csrftoken');

    if (is_valid_csrf_token(response_token)) {
      localStorage.setItem('playground_csrf_token', response_token);
      return true;
    }

    if (is_valid_csrf_token(cookie_token)) {
      localStorage.setItem('playground_csrf_token', cookie_token);
      return true;
    }

    return response.ok;
  } catch {
    return false;
  }
}

export function clear_auth_state() {
  [
    'token', 'user_id', 'role', 'first_name', 'last_name', 'email',
    'client_type', 'company_id', 'drive_id', 'otp_required', 'otp_verified',
    'is_playground_user', 'playground_context_id', 'playground_visitor_id',
    'playground_platforms', 'playground_csrf_token'
  ].forEach((k) => localStorage.removeItem(k));
}

export function demo_hosts() {
  const configured_hosts = String(process.env.VUE_APP_PLAYGROUND_DEMO_HOSTS || "")
    .split(",")
    .map(normalize_demo_host)
    .filter(Boolean);

  return new Set(configured_hosts);
}

function normalize_demo_host(host) {
  const value = String(host || "").trim().toLowerCase();
  if (!value) {
    return "";
  }

  try {
    return new URL(value).origin;
  } catch {
    return value.replace(/\/+$/, "");
  }
}

export function is_demo_domain() {
  const hosts = demo_hosts();
  const origin = window.location.origin.toLowerCase();
  const host = window.location.host.toLowerCase();
  const hostname = window.location.hostname.toLowerCase();

  return hosts.has(origin) || hosts.has(host) || hosts.has(hostname);
}


export function get_token() {
  const token = localStorage.getItem('token');

  if (!token) {
    localStorage.removeItem('user_id');
    localStorage.removeItem('role');
    localStorage.removeItem('first_name');
    localStorage.removeItem('last_name');
    localStorage.removeItem('email');
    localStorage.removeItem('client_type');
    localStorage.removeItem('otp_required');
    localStorage.removeItem('otp_verified');
    localStorage.removeItem('company_id');
    localStorage.removeItem('drive_id');
    localStorage.removeItem('is_playground_user');
    localStorage.removeItem('playground_csrf_token');
    return null;
  }
  return token;
}

const protected_routes = ['/home', '/drive', '/chat', '/settings', '/audit_trail', '/platform_management'];
const playground_entry_routes = ['/home', '/home_v1', '/drive', '/chat', '/create'];
const playground_prepare_failed_name = 'playground_prepare_failed';

const allowed_sso_apps = [
  'complyon',
  'orcaa',
  'proba',
  'xverdict',
  'engagenet',
  'proba_workflow'
];

function is_login_path(path) {
  return path === '/' || path === '/login';
}

function is_safe_app_redirect(next_url) {
  return typeof next_url === 'string' && next_url.startsWith('/') && !next_url.startsWith('//');
}

function is_public_route(to) {
  const public_paths = [
    '/',
    '/login',
    '/register',
    '/reset',
    '/auth/microsoft/success',
    '/marketplace/microsoft/activate',
    '/marketplace/microsoft/success',
    '/marketplace/microsoft/setup-submitted',
    '/marketplace/microsoft/error',
  ];
  const public_route_names = ['ResetPasswordSent', 'ResetLinkSent'];

  return (
    to.meta.public === true ||
    to.meta.requires_auth === false ||
    public_paths.includes(to.path) ||
    public_route_names.includes(to.name)
  );
}

function get_sso_next_redirect(to) {
  if (to.query.next && allowed_sso_apps.includes(to.query.next)) {
    if (!localStorage.getItem('sso_next')) {
      localStorage.setItem('sso_next', to.query.next);
    }
    return { path: to.path, query: {} };
  }

  return null;
}

function get_demo_redirect(to, from) {
  if (!is_demo_domain()) {
    return null;
  }

  if (sessionStorage.getItem(playground_prepare_failed_name) === '1') {
    return null;
  }

  if (!is_login_path(to.path)) {
    return null;
  }

  if (from.path && !is_login_path(from.path)) {
    return false;
  }

  return '/home';
}

function is_playground_entry_route(to) {
  return playground_entry_routes.includes(to.path);
}

function has_existing_auth_token() {
  return Boolean(localStorage.getItem('token'));
}

function clear_playground_prepare_failure() {
  sessionStorage.removeItem(playground_prepare_failed_name);
}

function mark_playground_prepare_failed() {
  sessionStorage.setItem(playground_prepare_failed_name, '1');
}

function is_playground_prepare_success(response, body) {
  return Boolean(response.ok && body.status === 'success' && body.data?.token && body.data?.user?.id);
}

function get_playground_prepare_failure_result(body) {
  return body.status === 'expired' || body.status === 'recovery' ? 'playground_recovery' : false;
}

function build_playground_user_details(user) {
  return {
    first_name: user.first_name || 'Playground',
    last_name: user.last_name || 'Visitor',
    email: user.email || '',
    role: user.role || 'Organization Admin',
    client_type: user.client_type || 'Organization',
    company_id: user.company_id || '',
  };
}

function store_playground_context(context) {
  if (context?.id) localStorage.setItem('playground_context_id', context.id);
}

function store_playground_visitor(visitor) {
  if (visitor?.id) localStorage.setItem('playground_visitor_id', visitor.id);
}

function store_playground_csrf_token(token) {
  if (is_valid_csrf_token(token)) localStorage.setItem('playground_csrf_token', token);
}

function store_playground_platforms(platforms) {
  localStorage.setItem('playground_platforms', JSON.stringify(platforms || []));
}

function store_playground_auth(data) {
  set_auth(data.token, data.user.id);
  set_user_details(build_playground_user_details(data.user));
  localStorage.setItem('is_playground_user', data.user.is_playground_user ? '1' : '0');
  store_playground_context(data.context);
  store_playground_visitor(data.visitor);
  store_playground_csrf_token(data.csrf_token);
  store_playground_platforms(data.platforms);
}

async function fetch_playground_prepare_response() {
  const response = await fetch(
    build_system_management_url(SYSTEM_MANAGEMENT_ENDPOINTS.prepare_playground),
    {
      method: 'GET',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    },
  );
  const body = await response.json();
  return { response, body };
}

function handle_failed_playground_prepare(body) {
  clear_auth_state();
  mark_playground_prepare_failed();
  return get_playground_prepare_failure_result(body);
}

async function handle_successful_playground_prepare(data) {
  clear_playground_prepare_failure();
  store_playground_auth(data);
  await ensure_csrf_token();
  return true;
}

async function prepare_playground_auth() {
  if (has_existing_auth_token()) {
    clear_playground_prepare_failure();
    return true;
  }

  try {
    const { response, body } = await fetch_playground_prepare_response();
    if (!is_playground_prepare_success(response, body)) return handle_failed_playground_prepare(body);
    return handle_successful_playground_prepare(body.data);
  } catch {
    clear_auth_state();
    mark_playground_prepare_failed();
    return false;
  }
}

async function get_playground_redirect(to) {
  if (!is_demo_domain()) {
    return null;
  }

  if (!is_playground_entry_route(to) || localStorage.getItem('token')) {
    return null;
  }

  const prepared = await prepare_playground_auth();
  if (prepared === true) {
    return null;
  }

  if (prepared === 'playground_recovery') {
    return { name: 'Login' };
  }

  return { name: 'Login' };
}

function should_redirect_to_login(to, token, is_public) {
  if (token) {
    return false;
  }

  if (to.path === '/create') {
    return true;
  }

  return protected_routes.includes(to.path) && !is_public;
}

export function internal_otp_bypass_hosts() {
  return new Set(
    String(process.env.VUE_APP_OTP_BYPASS_HOSTS || '')
      .split(',')
      .map(normalize_demo_host)
      .filter(Boolean)
  );
}

export function is_internal_otp_bypass_domain() {
  const hosts = internal_otp_bypass_hosts();
  const origin = window.location.origin.toLowerCase();
  const host = window.location.host.toLowerCase();
  const hostname = window.location.hostname.toLowerCase();

  return hosts.has(origin) || hosts.has(host) || hosts.has(hostname);
}

function should_redirect_to_otp(to, is_public) {
  if (is_internal_otp_bypass_domain()) {
    localStorage.removeItem('otp_required');
    localStorage.setItem('otp_verified', '1');
    return false;
  }
  const otp_required = localStorage.getItem('otp_required') === '1';
  const otp_verified = localStorage.getItem('otp_verified') === '1';

  return otp_required && !otp_verified && !is_public && to.path !== '/otp';
}

function get_auth_redirect(to) {
  const token = get_token();
  const is_public = is_public_route(to);

  if (is_internal_otp_bypass_domain()) {
    localStorage.removeItem('otp_required');
    localStorage.setItem('otp_verified', '1');

    if (to.path === '/otp') {
      return { name: 'IndividualDashboard' };
    }
  }

  if (should_redirect_to_login(to, token, is_public)) {
    return { name: 'Login', query: { next: to.fullPath } };
  }

  if (should_redirect_to_otp(to, is_public)) {
    return { name: 'OneTimePassword', query: { next: to.fullPath } };
  }

  return true;
}

router.beforeEach(async (to, from) => {
  if (!is_demo_domain() && localStorage.getItem('is_playground_user') === '1') {
    clear_auth_state();
  }

  const demo_redirect = get_demo_redirect(to, from);
  if (demo_redirect !== null) {
    return demo_redirect;
  }

  if (is_public_route(to)) {
    return true;
  }

  const sso_redirect = get_sso_next_redirect(to);
  if (sso_redirect) {
    return sso_redirect;
  }

  const playground_redirect = await get_playground_redirect(to);
  if (playground_redirect) {
    return playground_redirect;
  }

  if (localStorage.getItem('is_playground_user') === '1') {
    await ensure_csrf_token();
  }

  return get_auth_redirect(to);
});



export function get_user_id() {
  return localStorage.getItem('user_id');
}

export default router
